export default "__VITE_ASSET__CpIgnFEJ__"